// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-posts-js": () => import("./../../../src/pages/posts.js" /* webpackChunkName: "component---src-pages-posts-js" */),
  "component---src-templates-blog-post-js": () => import("./../../../src/templates/blog-post.js" /* webpackChunkName: "component---src-templates-blog-post-js" */),
  "component---src-templates-instagram-index-js": () => import("./../../../src/templates/instagram-index.js" /* webpackChunkName: "component---src-templates-instagram-index-js" */),
  "component---src-templates-instagram-post-js": () => import("./../../../src/templates/instagram-post.js" /* webpackChunkName: "component---src-templates-instagram-post-js" */)
}

